/* program groups are the landing pages describing: part-time, full-time, summer etc */

import React from "react";
import { Link } from "gatsby"
import Layout from "../../components/layout";
import PrimaryMenu from "../../components/primaryMenu";
import heroStyles from "../../components/css/hero.module.scss";
import SubPageNav from '../../sections/subPageNav'
import TitledSection from "../../sections/titledSection"
import Text from "../../sections/text"
import LearnMoreBox from "../../sections/learnMoreBox"
import "../../components/css/global.scss";
import AdmissionsLinks from "../../data/AdmissionsLinksData.json";
import EventBoxes from "../../sections/eventBoxes";

/* sections */
export default function() {

    const webinars = [
        {"title": "LIVE Q&A: CAREER NIGHT - Broadcasting & Online Media", "when": "Wednesday, January 13th, 2021", "time": "5pm Pacific Time", "where": "Streaming Live on Facebook & YouTube. Register for links and reminders", "learnMoreURL": "https://www.eventbrite.ca/e/live-qa-with-vanarts-tickets-135739966895", "shortDate": "Jan 13th"},
        {"title": "LIVE Q&A: CAREER NIGHT - Game Art & Design", "when": "Wednesday, January 13th, 2021", "time": "5pm Pacific Time", "where": "Streaming Live on Facebook & YouTube. Register for links and reminders", "learnMoreURL": "https://www.eventbrite.ca/e/live-qa-with-vanarts-tickets-135739966895", "shortDate": "Jan 27th"}
    ]
    
return (
    <Layout bHideSignup="true">
      <div className={heroStyles.heroNoSlide} style={{backgroundImage: "url(/assets/admissions@2x.png)"}}>
        <PrimaryMenu />
      </div>

      <SubPageNav title="Admissions" linksData={AdmissionsLinks} linkLabel="Start Your Future Today" type="subpage"/>
      
      <Text>
        <h1>Webinars</h1>
        <h2>You Are Invited</h2>
        <p>Wherever you are in the world, as long as you have an internet connection, you will be able to attend and have your questions answered at one of our upcoming webinars on Wednesdays, scheduled at different times convenient to your time zone.</p>

        <h2>Exciting and Informative</h2>
        <p>Ranging from general information about all programs to program-specific webinars, we are certain one of the upcoming webinars below will be perfect for you to attend. Click the Webinar name to view more information, and to register.</p>

        <EventBoxes data={webinars} />

      </Text>

      <LearnMoreBox cta="Visit Our FAQ Page">
        <h2>Do Your Still Have Questions? Visit Our FAQ Page Or Contact Us</h2>
      </LearnMoreBox>
     
      <LearnMoreBox cta="Apply Now">
        <h2>Ready To Apply?</h2>
        <h3>Full Time Programs</h3>
        <p>There is a non-refundable $100 application fee required too submit your application. After applying, an advisor will contact you regarding the additional materials required to complete your application.</p>
        
        <h3>Part Time &amp; Summer Courses</h3>
        <p>The full registration fee is required to submit your application.</p>
      </LearnMoreBox>

    </Layout>
  );
}
